import { createFileRoute } from '@tanstack/react-router';
import { FinanceImportScreen } from '../../screens/finance/Import';

export const Route = createFileRoute('/finance/import')({
  component: FinanceImportScreen,
});
